/** Statuts de passage infirmerie (aligné migration 015). */
export const NURSING_STATUS = {
  TRIAGE_PENDING: 'TRIAGE_PENDING',
  VITALS_RECORDED: 'VITALS_RECORDED',
  IN_CARE: 'IN_CARE',
  TRANSFERRED_MEDICAL: 'TRANSFERRED_MEDICAL',
  CLOSED: 'CLOSED'
};

const META = {
  [NURSING_STATUS.TRIAGE_PENDING]: {
    label: 'À traiter',
    variant: 'warning',
    step: 'acts'
  },
  [NURSING_STATUS.VITALS_RECORDED]: {
    label: 'Constantes enregistrées',
    variant: 'info',
    step: 'acts'
  },
  [NURSING_STATUS.IN_CARE]: {
    label: 'Prise en charge en cours',
    variant: 'success',
    step: 'acts'
  },
  [NURSING_STATUS.TRANSFERRED_MEDICAL]: {
    label: 'Transféré vers médecin',
    variant: 'primary',
    step: 'close'
  },
  [NURSING_STATUS.CLOSED]: {
    label: 'Visite clôturée',
    variant: 'secondary',
    step: 'close'
  }
};

export function getNursingStatusMeta(status) {
  const key = String(status || '').toUpperCase();
  return (
    META[key] || {
      label: key ? key.replace(/_/g, ' ') : 'Passage infirmerie',
      variant: 'secondary',
      step: 'acts'
    }
  );
}

/** Au moins une constante saisie sur le passage. */
export function hasVitalsOnConsultation(consultation) {
  if (!consultation) return false;
  const status = String(consultation.nursing_status || '').toUpperCase();
  if (status && status !== NURSING_STATUS.TRIAGE_PENDING) return true;
  return (
    consultation.weight_kg != null ||
    consultation.height_cm != null ||
    consultation.bp_systolic != null ||
    consultation.bp_diastolic != null ||
    consultation.temperature_c != null ||
    consultation.heart_rate_bpm != null
  );
}

export function isNursingPassageClosed(consultation) {
  const s = String(consultation?.nursing_status || '').toUpperCase();
  return s === NURSING_STATUS.CLOSED || s === NURSING_STATUS.TRANSFERRED_MEDICAL;
}
